import { Injector } from '@angular/core';
import { HttpDataService } from 'core/index';
import { environment } from 'environments/environment';

export class MarsHttpDataService extends HttpDataService {
  constructor(protected injector: Injector, protected apiEndPoint: string = '') {
    super(injector, apiEndPoint);
  }

  setBaseUrl(apiEndPoint) {
    this.baseUrl = `${environment.MARS_API_URL}${apiEndPoint}`;
  }
}
